import React from 'react';
import Accordion from './Accordion';

export interface CollapsibleSectionProps {
    title: string;
    subtitle?: string;
    defaultExpanded?: boolean;
    isExpanded?: boolean;
    onToggle?: (expanded: boolean) => void;
    className?: string;
    children: React.ReactNode;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
    title,
    subtitle,
    defaultExpanded = false,
    isExpanded,
    onToggle,
    className,
    children,
}) => (
    <Accordion
        variant="sunken"
        defaultExpanded={defaultExpanded}
        isExpanded={isExpanded}
        onToggle={onToggle}
        className={className}
        header={
            <span className="flex min-w-0 flex-1 items-center gap-[6px] text-[13px] leading-none">
                <span className="shrink-0 font-medium text-[var(--malachite-text-primary)]">
                    {title}
                </span>
                {subtitle ? (
                    <>
                        <span
                            aria-hidden="true"
                            className="shrink-0 text-[var(--malachite-text-placeholder)]"
                        >
                            -
                        </span>
                        <span className="min-w-0 flex-1 truncate tracking-[0.13px] text-[var(--malachite-text-primary)]">
                            {subtitle}
                        </span>
                    </>
                ) : null}
            </span>
        }
    >
        {children}
    </Accordion>
);

export default CollapsibleSection;
export { CollapsibleSection };
